import React, { useEffect, useState } from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg1.png";

const UploadForm = ({ userId }) => {
  const [isExperienced, setIsExperienced] = useState(null);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("adharCard", data.adharCard?.[0]);
    formData.append("panCard", data.panCard?.[0]);
    formData.append("Marksheet_of_10th", data.Marksheet_of_10th?.[0]);
    formData.append("Marksheet_of_12th", data.Marksheet_of_12th?.[0]);
    formData.append("Marksheet_of_Graduation", data.Marksheet_of_Graduation?.[0]);
    formData.append("Passport_or_Voter_ID", data.Passport_or_Voter_ID?.[0]);

    if (isExperienced) {
      formData.append("Latest_Salary_Slip", data.Latest_Salary_Slip?.[0]);
      formData.append("Resiganation_Letter_Of_Current", data.Resiganation_Letter_Of_Current?.[0]);
      formData.append("Appointment_Letter_Of_Current", data.Appointment_Letter_Of_Current?.[0]);
      formData.append("Offer_Letter_with_DOJ_and_salary_bifurcation", data.Offer_Letter_with_DOJ_and_salary_bifurcation?.[0]);
      formData.append("Bank_Statement_of_Salary_account", data.Bank_Statement_of_Salary_account?.[0]);
      formData.append("Email_ID_and_Contact_of_current_or_previous_HR", data.Email_ID_and_Contact_of_current_or_previous_HR || "");
    }

    try {
      const response = await fetch("http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/documents", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Network response was not ok");

      toast.success("Documents Submitted Successfully!", {
        position: "top-center",
        transition: Slide,
      });

      reset();
      setTimeout(() => {
        navigate("/EnteryCandidatePortel/feedback");
      }, 2000);
    } catch (error) {
      toast.error("Error submitting form. Please try again.");
      console.error("Error:", error);
    }
  };

  return (
    <div
      className="w-full flex items-center justify-center"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-lg"
        >
          <h2 className="text-2xl font-bold mb-4 w-full text-center">
            Upload Documents
          </h2>

          <div className="mb-6 flex flex-col items-center">
            <label className="block text-lg font-semibold mb-2 text-black">
              Are you Experienced?
            </label>
            <select
              onChange={(e) => setIsExperienced(e.target.value === "yes")}
              className="p-2 border rounded-md w-60"
              defaultValue=""
              required
            >
              <option value="" disabled>Select an option</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div className="font-serif font-bold text-red-500">
            All Documents are recommended to upload
          </div>

          {isExperienced !== null && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                {[
                  { id: "adharCard", label: "Aadhar" },
                  { id: "panCard", label: "PAN Card" },
                  { id: "Marksheet_of_10th", label: "10th Marksheet" },
                  { id: "Marksheet_of_12th", label: "12th Marksheet" },
                  { id: "Marksheet_of_Graduation", label: "Graduation Marksheet" },
                  { id: "Passport_or_Voter_ID", label: "Passport or Voter ID" },
                ].map((field) => (
                  <div className="form-group" key={field.id}>
                    <label htmlFor={field.id} className="text-sm font-serif text-black font-bold">
                      {field.label}
                    </label>
                    <input
                      type="file"
                      id={field.id}
                      {...register(field.id)}
                      className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                ))}

                {isExperienced && (
                  <>
                    <div className="form-group">
                      <label htmlFor="Latest_Salary_Slip" className="text-sm font-serif text-black font-bold">
                        Last 3 months' payslips (merged in one PDF)
                      </label>
                      <input
                        type="file"
                        id="Latest_Salary_Slip"
                        {...register("Latest_Salary_Slip")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="Resiganation_Letter_Of_Current" className="text-sm font-serif text-black font-bold">
                        Resignation/Relieving Letter
                      </label>
                      <input
                        type="file"
                        id="Resiganation_Letter_Of_Current"
                        {...register("Resiganation_Letter_Of_Current")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="Appointment_Letter_Of_Current" className="text-sm font-serif text-black font-bold">
                        Appointment Letter
                      </label>
                      <input
                        type="file"
                        id="Appointment_Letter_Of_Current"
                        {...register("Appointment_Letter_Of_Current")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="Offer_Letter_with_DOJ_and_salary_bifurcation" className="text-sm font-serif text-black font-bold">
                        Offer Letter with DOJ & Salary
                      </label>
                      <input
                        type="file"
                        id="Offer_Letter_with_DOJ_and_salary_bifurcation"
                        {...register("Offer_Letter_with_DOJ_and_salary_bifurcation")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="Bank_Statement_of_Salary_account" className="text-sm font-serif text-black font-bold">
                        Bank Statement (Salary Account)
                      </label>
                      <input
                        type="file"
                        id="Bank_Statement_of_Salary_account"
                        {...register("Bank_Statement_of_Salary_account")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="Email_ID_and_Contact_of_current_or_previous_HR" className="text-sm font-serif text-black font-bold">
                        Email of Current/Previous HR
                      </label>
                      <input
                        type="text"
                        id="Email_ID_and_Contact_of_current_or_previous_HR"
                        {...register("Email_ID_and_Contact_of_current_or_previous_HR")}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="w-full flex justify-center">
                <button
                  type="submit"
                  className="mt-6 bg-green-600 text-white p-2 px-5 rounded-md"
                >
                  Upload
                </button>
              </div>
            </>
          )}
        </form>
        <ToastContainer />
      </div>
    </div>
  );
};

export default UploadForm;
